import Core from "@/modules/core/service/Core";

const url = {
    findByUnit: "/api/incident/modernization?unit={0}",
}

export default {
    findByUnit (unitId) {
        return Core.method.get(url.findByUnit, unitId);
    },
}